import React, { useEffect, useState } from 'react';
import { Modal, Checkbox, Button, Typography } from 'antd';
import api from '../utils/api';

const { Title, Text } = Typography;

export const PLEDGES = [
  'मैं ऑफिस की गरिमा और अनुशासन बनाए रखूँगा।',
  'मैं समय पर ऑफिस आऊँगा और अपना काम ईमानदारी से पूरा करूँगा।',
  'मैं सीनियर्स और साथियों से सम्मान से बात करूँगा, और कोई समस्या हो तो HR या CEO को बताऊँगा।',
];

export default function WelcomePledge({ user }) {
  const [open, setOpen] = useState(false);
  const [ticks, setTicks] = useState(PLEDGES.map(() => false));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/pledge/status').then(r => setOpen(!!r.data?.required)).catch(() => {});
  }, []);

  const accept = async () => {
    setSaving(true);
    try { await api.post('/pledge/accept'); setOpen(false); }
    catch { setOpen(false); }
    finally { setSaving(false); }
  };

  const all = ticks.every(Boolean);

  return (
    <Modal open={open} closable={false} maskClosable={false} keyboard={false} footer={null} centered width={520}
      styles={{ mask: { backdropFilter: 'blur(6px)', background: 'rgba(20,20,40,0.6)' } }}>
      <div style={{ textAlign: 'center', margin: '-20px -24px 16px', padding: '26px 20px 20px', borderRadius: '8px 8px 0 0',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 55%, #f5576c 100%)', color: '#fff' }}>
        <img src="/logo192.png" alt="" style={{ height: 52, marginBottom: 8 }} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
        <Title level={3} style={{ color: '#fff', margin: 0 }}>🙏 स्वागत है, {user?.full_name} जी</Title>
        <Text style={{ color: 'rgba(255,255,255,0.9)' }}>Welcome to Bainsla Music &amp; Intube Media Office Team</Text>
      </div>
      {PLEDGES.map((p, i) => (
        <div key={i} style={{ padding: '10px 12px', marginBottom: 8, borderRadius: 10, border: `1px solid ${ticks[i] ? '#52c41a' : '#e8e8e8'}`, background: ticks[i] ? '#f6ffed' : '#fafafa' }}>
          <Checkbox checked={ticks[i]} onChange={(e) => setTicks(ticks.map((t, j) => j === i ? e.target.checked : t))}>
            <span style={{ fontSize: 15 }}>{p}</span>
          </Checkbox>
        </div>
      ))}
      <div style={{ textAlign: 'center', margin: '14px 0 4px', fontSize: 15, fontWeight: 600, color: '#722ed1' }}>
        यहाँ हम सिर्फ काम नहीं करते, हम मिलकर एक पहचान बनाते हैं।
      </div>
      <Button type="primary" block size="large" disabled={!all} loading={saving} onClick={accept} style={{ marginTop: 8, height: 46, fontWeight: 600 }}>
        Done — Dashboard खोलें
      </Button>
    </Modal>
  );
}
